const initialState = {
  isFetching: false,
  isFetched: false,
  success: false,
  error: false,
  statusError: null,
  personalInfo: null,
  seed: null,
  deviceData: null
}

export const ACTION_TYPES = {
  EASYTOKEN_REQUEST: 'EASYTOKEN_REQUEST',
  EASYTOKEN_SUCCESS: 'EASYTOKEN_SUCCESS',
  EASYTOKEN_ERROR: 'EASYTOKEN_ERROR',
  EASYTOKEN_CREATE_REQUEST: 'EASYTOKEN_CREATE_REQUEST',
  EASYTOKEN_CREATE_SUCCESS: 'EASYTOKEN_CREATE_SUCCESS',
  EASYTOKEN_CREATE_ERROR: 'EASYTOKEN_CREATE_ERROR'
}

export const getEasyToken = () => ({
  type: ACTION_TYPES.EASYTOKEN_REQUEST
})

export const postEasyToken = (payload = {}) => ({
  type: ACTION_TYPES.EASYTOKEN_CREATE_REQUEST,
  payload
})

const easyToken = (state = initialState, { type, payload, personalInfo }) => {
  switch (type) {
    case ACTION_TYPES.EASYTOKEN_REQUEST: {
      return {
        ...state,
        isFetching: true
      }
    }
    case ACTION_TYPES.EASYTOKEN_SUCCESS:
      return {
        ...state,
        isFetching: false,
        isFetched: true,
        success: true,
        seed: payload.data.value.deviceSeed,
        deviceData: {
          confirmedDate: payload.data.value.confirmedDate,
          deviceId: payload.data.value.deviceId,
          deviceModel: payload.data.value.deviceModel,
          isActive: payload.data.value.isActive
        }
      }
    case ACTION_TYPES.EASYTOKEN_ERROR:
      return {
        ...state,
        isFetching: false,
        isFetched: true,
        success: false,
        error: true,
        statusError: payload.response.status,
        personalInfo
      }
    case ACTION_TYPES.EASYTOKEN_CREATE_REQUEST: {
      return {
        ...state,
        isFetching: true,
        isFetched: false,
        success: false,
        error: false,
        statusError: null
      }
    }
    case ACTION_TYPES.EASYTOKEN_CREATE_SUCCESS:
      return {
        ...state,
        isFetching: false,
        isFetched: true,
        success: true,
        seed: payload.data.seed
      }
    case ACTION_TYPES.EASYTOKEN_CREATE_ERROR:
      return {
        ...state,
        isFetching: false,
        isFetched: true,
        success: false,
        error: true
      }
    default:
      return state
  }
}

export default easyToken
